// extracted by css-extract-rspack-plugin
export default {"markdown":"L8Hshubzj4UHZ7aB"};